<ion-item button>
  <ion-label [position]="position">Outlet Type</ion-label>
  <ion-input (ionFocus)="handleFocus($event)" [value]="label" readonly></ion-input>
</ion-item>
